import i18n from "en.yml?namespace=en.customer";

window.locales = i18n;
